<template>
  <div class="A" @click="$router.push({name:'list',query:{id:1}})">
      <template v-for="(item, index) in 74">
          <img v-show="Index%74==index" :src="require('../../assets/images/A/'+index+'.png')" :key="index" alt="">
      </template>
  </div>
</template>

<script>
export default {
  components:{},
  props:['Index'],
  data(){
    return {
        
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){
      
  },
  mounted(){}
}
</script>
<style scoped>
.A{
  width: 1rem;
  height: 1rem;
}
.A img{
   
    width: 100%;
    height: 100%;
}
</style>